import { shuffleArray } from 'lib/utilityFunctions';
import { IN_BETWEEN_BRACKETS_RGX, LEVEL_TYPES } from '../data/constants';

let curriculum;
export const setCurriculum = (c) => { curriculum = c; };

export const getCurriculum = () => curriculum;

// dividing by 2 to account for a side b side
export const getLevelCount = () => getCurriculum().levels.length / 2;

export const getAllLevelsIndex = () => {
  const levels = Array.from(Array(getLevelCount()));
  return levels.map((_, index) => index);
};

export const getLevelById = levelId => getCurriculum().levels.find(({ level }) => levelId === level);

export const getMainVerb = levelId => getLevelById(levelId).infinitive || '';

export const getItemsCount = (levelId) => {
  const { items, sentences } = getLevelById(levelId);

  return {
    standardItemsCount: items.length || 0,
    sentenceItemsCount: sentences.length || 0,
  };
};

export const getOnboardingItem = () => getCurriculum().onboarding;

export const getLevelType = (levelId) => {
  const { type } = getLevelById(levelId);
  return Object.values(LEVEL_TYPES).includes(type) ? type : LEVEL_TYPES.VERB;
};

export const getStandardItemsContent = (levelId) => {
  const { items } = getLevelById(levelId);
  return {
    verbOptions: items.map(({ verb }) => verb),
    pronounOptions: items.map(({ pronoun }) => pronoun),
    answerMap: items.reduce((acc, { pronoun, verb }) => ({ ...acc, [pronoun]: verb, [verb]: pronoun }), {}),
    items,
  };
};

export const getSentenceItems = (levelId) => {
  const { sentences } = getLevelById(levelId);
  return sentences.map(({ sentence, options, id }) => {
    const result = sentence.match(IN_BETWEEN_BRACKETS_RGX);
    const [, target] = result;
    return { sentence, target, options: shuffleArray(options), id };
  });
};

export const getInstructionChartContent = levelId => getLevelById(levelId).chart;
